export const CedeIconRed = () => {
  return (
    <svg width="92" height="92" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.00623851 22.0792C0.00623851 9.88164 9.89348 0 22.084 0H69.9222C82.119 0 92 9.88789 92 22.0792V69.9207C92 82.1183 82.1127 92 69.9222 92H21.9716C9.8373 92 0 82.162 0 70.0269V22.073L0.00623851 22.0792Z"
        fill="url(#paint0_linear_8995_91904)"
      />
      <path
        d="M5.31694 24.8383C5.31694 14.0514 14.0619 5.30588 24.848 5.30588H67.1684C77.9544 5.30588 86.6994 14.0514 86.6994 24.8383V67.1615C86.6994 77.9483 77.9544 86.6938 67.1684 86.6938H24.7481C14.012 86.6938 5.31069 77.992 5.31069 67.2551V24.832L5.31694 24.8383Z"
        fill="black"
      />
      <path
        d="M10.6214 27.5974C10.6214 18.2151 18.2241 10.6119 27.6057 10.6119H64.4082C73.7898 10.6119 81.3925 18.2151 81.3925 27.5974V64.4024C81.3925 73.7847 73.7898 81.3878 64.4082 81.3878H27.5246C18.1929 81.3878 10.6276 73.8221 10.6276 64.4836V27.5974H10.6214Z"
        fill="white"
      />
      <path
        d="M38.2521 49.5311C41.7166 43.5298 40.7255 36.471 36.0383 33.7646C31.3511 31.0583 24.7428 33.7293 21.2782 39.7305C17.8137 45.7318 18.8048 52.7906 23.492 55.4969C28.1792 58.2033 34.7875 55.5323 38.2521 49.5311Z"
        fill="black"
      />
      <path
        d="M68.7162 55.5469C73.4034 52.8406 74.3945 45.7817 70.9299 39.7805C67.4654 33.7793 60.8571 31.1083 56.1699 33.8146C51.4827 36.5209 50.4915 43.5798 53.9561 49.581C57.4207 55.5822 64.029 58.2532 68.7162 55.5469Z"
        fill="black"
      />
      <path
        d="M46.1032 59.7516C46.1032 59.7516 43.4691 59.6455 42.5265 60.3197C41.584 60.9938 41.6464 62.0363 41.6464 62.0363C41.6464 62.0363 41.5216 63.1038 41.8337 63.7967C42.1458 64.4896 43.9747 64.371 44.8735 65.9128C44.8735 65.9128 45.6974 66.1938 46.1032 66.1126"
        fill="black"
      />
      <path
        d="M46.1032 59.7516C46.1032 59.7516 48.7374 59.6456 49.68 60.3198C50.6225 60.994 50.5601 62.0364 50.5601 62.0364C50.5601 62.0364 50.6849 63.1039 50.3728 63.7968C50.0607 64.4897 48.2318 64.3711 47.333 65.913C47.333 65.913 46.5089 66.1938 46.1032 66.1126"
        fill="black"
      />
      <path
        d="M34.6344 49.1967C36.6718 49.1967 38.3234 47.5449 38.3234 45.5074C38.3234 43.4699 36.6718 41.8182 34.6344 41.8182C32.5971 41.8182 30.9455 43.4699 30.9455 45.5074C30.9455 47.5449 32.5971 49.1967 34.6344 49.1967Z"
        fill="white"
      />
      <path
        d="M57.7587 49.2527C59.796 49.2527 61.4476 47.601 61.4476 45.5635C61.4476 43.526 59.796 41.8743 57.7587 41.8743C55.7213 41.8743 54.0697 43.526 54.0697 45.5635C54.0697 47.601 55.7213 49.2527 57.7587 49.2527Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8995_91904"
          x1="46"
          y1="0"
          x2="46"
          y2="102.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F44336" />
          <stop offset="1" stopColor="#FF5E61" stopOpacity="0.4" />
        </linearGradient>
      </defs>
    </svg>
  );
};
